export default __webpack_public_path__ + "static/media/score.230e152d.svg";